import { render, staticRenderFns } from "./SGoods.vue?vue&type=template&id=bdc385cc&scoped=true"
import script from "./SGoods.vue?vue&type=script&lang=js"
export * from "./SGoods.vue?vue&type=script&lang=js"
import style0 from "./SGoods.vue?vue&type=style&index=0&id=bdc385cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc385cc",
  null
  
)

export default component.exports